import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { AttorneyService } from "../../../../services/ClientService";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";

export default function ServiceContacts({
    attorney,
}: {
    attorney: APIModels.Attorney;
}) {
    const never = "never" as const;
    const [serviceContacts, setserviceContacts] = useState(
        [] as APIModels.ServiceContact[]
    );

    const refreshData = () => {
        if (attorney.id != "") {
            AttorneyService.serviceContacts({
                attorneyId: attorney.id ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true) {
                        setserviceContacts(
                            resp.data as APIModels.ServiceContact[]
                        );
                        console.log("ServiceContacts " + attorney.id);
                    } else {
                        console.log("error");
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    useEffect(() => {
        console.log("ServiceContacts " + attorney.id);
        AttorneyService.serviceContacts({ attorneyId: attorney.id ?? "" }).then(
            (resp) => {
                if (resp.successful === true) {
                    setserviceContacts(resp.data as APIModels.ServiceContact[]);
                    console.log("ServiceContacts " + attorney.id);
                } else {
                    console.log("error");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [attorney]);

    return (
        <div className="card text-center">
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "ID",
                                field: "id",
                                editable: never,
                            },
                            {
                                title: "First Name",
                                field: "firstName",
                            },
                            {
                                title: "Middle Name",
                                field: "middleName",
                            },
                            {
                                title: "Last Name",
                                field: "lastName",
                            },
                            {
                                title: "Full Name",
                                field: "fullName",
                            },
                            {
                                title: "Email Address",
                                field: "emailAddress",
                            },
                            {
                                title: "Active",
                                field: "active",
                                type: "boolean" as const,
                            },
                        ]}
                        data={serviceContacts}
                        title="Service Contacts"
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    AttorneyService.addServiceContacts({
                                        body: {
                                            ...newData,
                                            attorneyID: attorney.id,
                                            active: true,
                                        },
                                    }).then(
                                        (resp) => {
                                            console.log(
                                                "ServiceContacts Add success " +
                                                    newData.active
                                            );
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                    AttorneyService.updateServiceContacts({
                                        id: oldData?.id ?? "",
                                        body: newData!,
                                    }).then(
                                        (resp) => {
                                            console.log(
                                                "ServiceContacts update success " +
                                                    newData.active +
                                                    " " +
                                                    oldData!.active
                                            );
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowDelete: (oldData) =>
                                new Promise((resolve, reject) => {
                                    AttorneyService.deleteServiceContacts({
                                        id: oldData.id ?? "",
                                    }).then(
                                        (resp) => {
                                            console.log(
                                                "ServiceContacts Add success " +
                                                    attorney.id
                                            );
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
